import { Component, HostListener } from '@angular/core';
import { LocationManagerService } from '../../api/managers/location-manager.service';

@Component({
    selector: 'app-weather',
    templateUrl: './weather.component.html',
    styleUrls: ['./weather.component.less']
})
export class WeatherComponent
{
    forecastIsDisplayed = false;

    constructor(public locationManager: LocationManagerService) { }

    @HostListener('document:click', ['$event']) clickedOutside()
    {
        this.forecastIsDisplayed = false;
    }
}
